import { Injectable } from '@angular/core';
import { SharedService } from './shared.service';
import { Utility } from '../core/common';


type testVariant = { variant: string; weight?: number, active?: boolean; };

const testLocalStorageKey = 'AB-test-variants';
@Injectable({
  providedIn: 'root'
})
export class AbTestService {
  constructor(private sharedService: SharedService) { }
  
  private get abTests(): { [id: string]: testVariant[] } {
    if (!this.sharedService.isBrowser)
      return {};

    const abTests = localStorage.getItem(testLocalStorageKey);
    return abTests ? JSON.parse(abTests) : {};
  }
  
  defineTest(testName: string, testVariants: string[]) {
    if (!this.sharedService.isBrowser) return;

    this.defineWeightedTest(testName, testVariants.map(v => <testVariant>{ variant: v, weight: 1 }))
  }
  defineWeightedTest(testName: string, variants: testVariant[]) {
    if (!this.sharedService.isBrowser) return;

    let tests = Utility.clone(this.abTests);
    AbTestService.setActiveVariant(tests, testName, variants);
    tests[testName] = variants;

    localStorage.setItem(testLocalStorageKey, JSON.stringify(tests));
  }
  removeTest(testName: string) {
    if (!this.sharedService.isBrowser) return;
    let tests = Utility.clone(this.abTests);
    delete tests[testName];
    localStorage.setItem(testLocalStorageKey, JSON.stringify(tests));
  }

  private static setActiveVariant(tests: { [id: string]: testVariant[] }, testName: string, variants: testVariant[]) {
    let active = variants.find(v => v.variant == tests[testName]?.find(v => v.active)?.variant);
    if (active)
      active.active = true;
    else {
      let totalWeight = variants.reduce((acc, v) => acc + (v.weight || 1), 0);
      let random = Math.random() * totalWeight;
      let weightSum = 0;
      active = variants.find(v => {
        weightSum += v.weight || 1;
        return random < weightSum;
      });
      active.active = true;
    }
  }

  getVariant(testName: string): string {
    if (!this.sharedService.isBrowser)
      return undefined;

    return this.abTests[testName]?.find(v => v.active)?.variant;
  }
  getAbTests(): { key: string; value: string; }[] {
		return Object.keys(this.abTests).map(key => ({ key, value: this.getVariant(key) }));
	}


}
